import {
  breakpoints as sharedBreakpoints,
  palette as basePalette,
  props,
  pxToRem,
  shape,
  overrides as sharedOverrides,
  spacing as sharedSpacing,
} from '@fluentsms/agentnet-web-components';
import { createMuiTheme } from '@material-ui/core';
import palette from 'ui-kit/theme/palette';
import typography from './typography';

const overrides = {
  ...sharedOverrides,
  MuiCssBaseline: {
    '@global': {
      a: {
        color: basePalette.primary.main,
        textDecoration: 'underline',
        '&:hover': {
          textDecoration: 'none',
        },
        '&:active, &:focus': {
          color: basePalette.primary.main,
        },
      },
      blockquote: {
        ...typography.overline,
        borderLeft: `8px solid ${basePalette.primary.light}`,
        color: basePalette.text.secondary,
        margin: sharedSpacing(3, 0),
        padding: sharedSpacing(0, 2),
        '& div.paragraph': {
          ...typography.overline,
        },
      },
      pre: {
        backgroundColor: '#f0f1f2',
        border: `1px solid ${basePalette.divider}`,
        borderRadius: shape.borderRadius,
        display: 'block',
        fontFamily: 'monospace',
        fontSize: pxToRem(14),
        margin: sharedSpacing(2, 0),
        overflow: 'auto',
        padding: sharedSpacing(0.5, 1),
      },
      h1: {
        ...typography.h1,
      },
      h2: {
        ...typography.h2,
        color: basePalette.primary.main,
        margin: sharedSpacing(2, 0),
      },
      h3: {
        ...typography.h3,
        color: basePalette.primary.main,
        margin: sharedSpacing(2, 0),
      },
      h4: {
        ...typography.h4,
        color: basePalette.primary.main,
        margin: sharedSpacing(2, 0),
      },
      h5: {
        ...typography.h5,
        color: basePalette.primary.main,
        margin: sharedSpacing(2, 0),
      },
      h6: {
        ...typography.h6,
        color: basePalette.primary.main,
        margin: sharedSpacing(2, 0),
      },
      li: {
        marginBottom: sharedSpacing(1),
        '&:last-child, & .paragraph': {
          marginBottom: 0,
        },
      },
    },
  },
  MuiTypography: {
    root: {
      '& a': {
        color: basePalette.primary.main,
        textDecoration: 'underline',
        '&:hover': {
          textDecoration: 'none',
        },
        '&:active, &:focus, &:visited': {
          color: basePalette.primary.main,
        },
      },
    },
  },
};

const kbTheme = createMuiTheme({
  breakpoints: {
    values: {
      ...sharedBreakpoints.values,
      md: 960,
    },
  },
  overrides: overrides,
  palette,
  props,
  shape,
  spacing: sharedSpacing,
  typography,
});

export default kbTheme;
